import { configureStore } from '@reduxjs/toolkit';
import searchSlice from './searchSlice';
import commonSlice from './commonSlice';

export default configureStore({
  reducer: {
    searchSlice,
    commonSlice
  },
});